<template>
<a href="#" class="list-group-item list-group-item-action" :title="user.tooltip" v-on:click.prevent="fullElementClicked">
	<div class="d-flex justify-content-between flex-wrap align-items-center inner">
		<div>
			<i v-if="user.isOnVacation" class="fa fa-umbrella-beach text-warning" :title="user.description+' is on vacation for the day'"></i>
			<i v-if="user.isScheduledOff" class="fa fa-ban text-warning" :title="user.description+' is scheduled off for the day'"></i>
			<i v-if="user.isSick" class="fa fa-ban text-warning" :title="user.description+' is sick for the day'"></i>
			{{ user.description }}
		</div>
		<span v-if="compiledHours && compiledHours > 0" class="badge badge-primary">{{compiledHours.toFixed(1)}} hrs</span>

		<i class="fa fa-plus icon-button" v-on:click="addClick"></i>
	</div>
</a>
</template>
<script type="text/javascript">
import ScheduleMixins from "@/mixins/ScheduleMixins.js"

export default {
	name: "SelectorListEmployeeItem",
	mixins: [ScheduleMixins],
	props: [
		"user",
		"fullElementClickable",
		"selectedDate",
		"compiledHours"
	],
	watch: {
		'$store.scheduleEvents'() {
			//console.log("store change")
			this.$forceUpdate()
		},
		compiledHours() {
			console.log("compiled hours change")
		}
	},
	methods: {
		addClick() {
			if (!this.fullElementClickable)
				this.$emit('addClick')
		},
		fullElementClicked() {
			if (this.fullElementClickable)
				this.$emit("addClick")
		}
	}
}
</script>